<template>
  <QuesCard
    :maxwidth="maxwidth"
    :ques="ques"
    :isEdit="isEdit"
    :showIsAssign="true"
    @quesDel="$emit('quesDel')"
  >
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}日期題
    </template>
    <v-card-text class="text-start" slot="content">
      <template v-if="!isEdit">
        <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx">
          {{ ques.serial == null ? '' : ques.serial + '. ' }}{{ name }}
        </div>
        <!-- 加上題號在非編輯狀態 -->
      </template>
      <v-textarea
        v-if="isEdit"
        outlined
        rows="1"
        auto-grow
        v-on:click="checkDef()"
        v-model="ques.cnName"
        class="peter-text"
      ></v-textarea>
      <v-row class="mt-2 ml-0 pr-3">
        <v-file-input
          v-if="isEdit"
          chips
          filled
          class="pt-0"
          v-model="ques.headingFile"
          accept="image/*"
          @change="onImgChangeHeading($event)"
          label="File input"
        >
        </v-file-input>
      </v-row>
      <v-row>
        <v-col class="pa-0 text-center" >
          <!-- <v-img></v-img> 改成 <img> 來顯示圖片原始的最大尺寸 max-width控制不破圖 -->
          <img
            v-if="ques.questHeadingPic"
            :src="
              ques.questHeadingPic.startsWith('data')
                ? ques.questHeadingPic
                : $store.state.server + ques.questHeadingPic
            "
            style="max-width: 100%"
          />
        </v-col>
      </v-row>

      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="ques.value"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="ques.value"
            prepend-icon="event"
            readonly
            v-on="on"
            class="peter-text"
          ></v-text-field>
        </template>
        <v-date-picker v-model="ques.value" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(ques.value)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    maxwidth: {
      type: Number,
      default: null,
    },
    ques: {
      type: Object,
      default: () => {
        return {
          title: '日期題',
          cnName: '日期題題目內容',
          value: null,
        }
      },
    },
  },
  computed: {
    QType() {
      return this.$store.state.QType
    },
  },
  methods: {
    onImgChangeHeading(file) {
      if (!file) {
        this.ques.questHeadingPic = null
      } else {
        var fileReader = new FileReader()
        fileReader.addEventListener('load', (e) => {
          this.ques.questHeadingPic = e.target.result
        })
        fileReader.readAsDataURL(file)
      }
    },
    checkDef() {
      if (this.QType.DATE.template.cnName === this.ques.cnName) {
        this.ques.cnName = ''
      }
    },
  },
  data() {
    return {
      modal: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.thiscard {
  border-radius: 10px;
  cursor: grab;
}
</style>
